import { useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import WSTextField from '../../../Components/TextBox/WSTextBox';

export const Step4ShiftAttendance = () => {
  const { register,control} = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Shift Name" fullWidth {...register('shiftName')} /> */}
        <WSTextField id="shiftName" label={"Shift Name"} control={control} name='shiftName' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Attendance Mode" fullWidth {...register('attendanceMode')} /> */}
        <WSTextField id="attendanceMode" label={"Attendance Mode"} control={control} name='attendanceMode' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Biometric ID" fullWidth {...register('biometricId')} /> */}
        <WSTextField id="biometricId" label={"Biometric ID"} control={control} name='biometricId' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Weekly Off Days (Comma Separated)" fullWidth {...register('weeklyOffDays')} /> */}
        <WSTextField id="weeklyOffDays" label={"Weekly Off Days (Comma Separated)"} control={control} name='weeklyOffDays' />
      </Grid>
    </Grid>
  );
};